export default __webpack_public_path__ + "static/media/flag22.8642132e.png";